// List of common personal email domains
const PERSONAL_EMAIL_DOMAINS = [
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'outlook.com',
  'aol.com',
  'icloud.com',
  'mail.com',
  'proton.me',
  'protonmail.com',
  'me.com',
  'live.com',
  'msn.com',
  'cloud.com',
  'ymail.com',
  'zoho.com',
  'inbox.com',
  'fastmail.com',
];

interface CompanyEmailInfo {
  isWorkEmail: boolean;
  companyDomain?: string;
  suggestedCompanyName?: string;
  suggestedWebsite?: string;
}

export const analyzeWorkEmail = (email: string): CompanyEmailInfo | null => {
  if (!email || !email.includes('@')) {
    return null;
  }

  const [, domain] = email.toLowerCase().split('@');

  // Check if it's a personal email domain
  if (PERSONAL_EMAIL_DOMAINS.includes(domain)) {
    return { isWorkEmail: false };
  }

  // Remove common TLDs to get potential company name
  const domainParts = domain.split('.');
  if (domainParts.length < 2) {
    return { isWorkEmail: true, companyDomain: domain };
  }

  // Keep the full domain including TLD
  const fullDomain = domain;
  
  // Remove the TLD (e.g., .com, .org, etc.) for company name suggestion
  const baseDomain = domainParts.slice(0, -1).join('.');
  
  // Convert domain to a presentable company name
  const suggestedCompanyName = baseDomain
    .split(/[-_.]/)
    .map(word => {
      // Handle special cases for common abbreviations
      if (word.toLowerCase() === 'inc' || word.toLowerCase() === 'llc') {
        return word.toUpperCase();
      }
      // Capitalize first letter of each word
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');

  return {
    isWorkEmail: true,
    companyDomain: fullDomain,
    suggestedCompanyName: suggestedCompanyName.trim(),
    suggestedWebsite: `https://www.${fullDomain}`
  };
};
